import { render, staticRenderFns } from "./Shelf.vue?vue&type=template&id=7a549c24&scoped=true"
import script from "./Shelf.vue?vue&type=script&lang=js"
export * from "./Shelf.vue?vue&type=script&lang=js"
import style0 from "./Shelf.vue?vue&type=style&index=0&id=7a549c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a549c24",
  null
  
)

export default component.exports